import { MoneyCatalogDetailStatusEnum } from "../../enums/statusEnums";

const getFieldValue = (field, value) => {
  return value !== null ? value : "-";
};

export const detailsColumns = [
  {
    field: "id",
    headerName: "ID Λεπτομέρειας Χρηματικού Καταλόγου",
    width: 140,
  },
  {
    field: "money_catalog_id",
    headerName: "ID Χρηματικού Καταλόγου",
    width: 150,
  },
  {
    field: "line_no",
    headerName: "Αριθμός Γραμμής",
    width: 150,
  },
  {
    field: "afm",
    headerName: "ΑΦΜ",
    width: 150,
  },
  {
    field: "pay_id",
    headerName: "Ταυτότητα Οφειλής",
    width: 300,
  },
  {
    field: "original_amount",
    headerName: "Αρχικό Ποσό",
    width: 150,
  },
  {
    field: "date_created",
    headerName: "Ημερομηνίας βεβαίωσης",
    width: 170,
  },
  {
    field: "crosscheck_status",
    headerName: "Κατάσταση",
    width: 150,
    valueFormatter: (params) => {
      return MoneyCatalogDetailStatusEnum[params.value] || "-";
    },
  },
  {
    field: "kede_debt_id",
    headerName: "ID Οφειλής Βεβαίωσης",
    width: 140,
    valueFormatter: (params) => {
      return getFieldValue(params.field, params.value);
    },
  },
  {
    field: "m06_id",
    headerName: "ID Συνδρομής",
    width: 100,
    valueFormatter: (params) => {
      return getFieldValue(params.field, params.value);
    },
  },
];
